import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getVisionVideoArtifacts: build.query({
      query: ({ workOrderId }) => ({
        url: `/api/v1/vision/video-artifacts/work-orders/${workOrderId}`,
      }),
    }),
  }),
})

export const { useGetVisionVideoArtifactsQuery, useLazyGetVisionVideoArtifactsQuery } = extendedApi
